// components/IngredientsForm.jsx
import React from 'react';
import { useIngredientsForm } from './useIngredientsForm';
import { Tooltip } from '../../atoms';
import { InputSelect,  InputSelectEn } from '../../atoms';
import {timeInputs, complex, process, group, tool, hint, recipeErrors} from '../../../constants/constants' 
import {AutoComplete, useFormErrors, groupedIngredient} from '../../../utils/utils.js'
import { Select, SelectEn} from '..' 

export const IngredientsForm = ({ ingredientsLib, initialData = [], onIngredientsChange }) => {
  const {
    ingredientsData,
    selectedIngredient,
    filteredIngredients,
    hidden,
    errors,
    totalIngredients,
    isFormValid,
    handleInputChange, 
    handleSelect,
    handleChange,
    handleAdd,
    isOpenMeasure,
    handleFocusMeasure,
    handleFocusGroup,
    handleDelete,
    handleWeightChange,
    isOpenGroup,
    isOpenProcess,
    handleFocusProcess,
    getIngredientsForServer,
    setHidden
  } = useIngredientsForm(initialData, ingredientsLib, onIngredientsChange);
  console.log(initialData)
  const {error, validate, setError} = useFormErrors()
   console.log(filteredIngredients, hidden, selectedIngredient.name, error.ingredients)
  return (
    <> 
        <fieldset className='form__fieldset fieldset__ingredient'> 
          <legend className='form__legend font20EB color'>Добавить ингредиенты</legend>
          {Object.keys(groupedIngredient(ingredientsData)).map((group) => (
            <div className='form__data_groupe' key={group}>
              <h3 className='form__group_title font20EB'>{group}</h3>
              {groupedIngredient(ingredientsData)[group].map((item, index) => (
                <IngredientItem 
                  key={index}
                  item={item}
                  index={index} 
                  onWeightChange={handleWeightChange}
                  onDelete={handleDelete} 
                  error={error}
                  
                />
              ))}
            </div>
          ))} 
      </fieldset>
        <fieldset className='form__fieldset fieldset__ingredient'>  
          <div className='form__data_add-ingredient'>
            <label className='form__label form__label_ingredient font20EB color'>
              <Tooltip content={hint.ingredient} type='abs'/>
              <input 
                type='text'  
                title=''
                value={selectedIngredient.name || ''}
                onChange={handleInputChange}
                placeholder= 'Начните вводить ингредиент'
                name='ingredients' 
                id='ingredients'  
                autoComplete="off" 
                className={`form__input font20Norm ${error.ingredients ? 'form__error' : ''}`}
                aria-describedby={`${'ingredients'}-error`} 
              />  
              {error.ingredients ? (
                <span className="form__text_error font14Norm">
                   {error.ingredients}
                </span>
              ) : (
  <>
    {filteredIngredients.length > 0 && hidden && (
      <div className={`add-recipe__autocomplete ${hidden ? 'add-recipe_hidden' : ''}`}>
        {filteredIngredients.map((item, index) => (
          <AutoComplete key={index} item={item} onClick={handleSelect} />
        ))}
      </div>
    )}
    
    {filteredIngredients.length === 0 && hidden  && selectedIngredient.name && (
      <div className={`add-recipe__autocomplete ${hidden ? 'add-recipe_hidden' : ''}`}>
        <p className='add-recipe__autocomplete_err colorRed'>
        <p className='gg-no-dish'></p> 
           <p className=' font20Nprm '>Ингредиент не найден</p> 
        </p>
        
      </div>
    )}
  </>
)}
            </label>
            <label className='form__label_count font20Norm'>
              <input
                type="number"
                id="totalWeight"
                name="totalWeight"
                min="0"
                max='1000'
                value={selectedIngredient.totalWeight || ''}
                placeholder="0"
                onChange={handleChange}
                className={`form__input_weight font20Norm ${error.totalWeight ? 'form__input_error' : ''}`}
              />  
              {error.totalWeight && <span  className="form__text_error font14Norm">{error.totalWeight}</span>}
            </label>  
            <label className={`font20EB color form__label_measure`}  onClick={handleFocusMeasure}> 
            <div className={`form__input_select_block ${isOpenMeasure ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocusMeasure}> 
          
          <Select  
          onChange={handleChange}  
          value={selectedIngredient.measure}
          lib={selectedIngredient.availableMeasures}
          actions='Мера'
          name='measure'
          id='measure'  
        /> 
        </div>
        {error.choisMeasure && <span  className="form__text_error font14Norm">{error.choisMeasure}</span>}
        <Tooltip content={hint.measure} type='abs'/>
           </label> 
          <label className={`font20EB color form__label_group`} onClick={handleFocusGroup}>   
          <div className={`form__input_select_block ${isOpenGroup ? 'form__label_complex_open': 'form__label_complex_close'}`}  >
          <Select  
              onChange={handleChange}  
              value={selectedIngredient.group || ''} 
              actions='Группа'
              name='group'
              id='group' 
              lib={group}
              /> 
              </div>
              <Tooltip content={hint.group} type='abs'/>
              
          </label> 
          <label className={`font20EB color form__label_process`}> 
          <div className={`form__input_select_block ${isOpenProcess ? 'form__label_complex_open': 'form__label_complex_close'}`}  onClick={handleFocusProcess}> 
            <SelectEn  
              onChange={handleChange}  
              value={selectedIngredient.note || ''} 
              actions='Обработка'
              name='note'
              id='note' 
              lib={process}
              /> 
               </div>
              <Tooltip content={hint.process} type='abs'/>
              {error.note && <span  className="form__text_error font14Norm">{error.note}</span>}
          </label>
      
      </div>
      <button  
        onClick={handleAdd}
        disabled={!isFormValid}
        type='button'  
        className={`buttonGreen ${!isFormValid ? 'buttonDisabled' : ''}`} 
      > Добавить ингредиент</button>
      </fieldset>
      </> 
  );
};

// Компонент для отображения одного ингредиента
const IngredientItem = ({ item, onWeightChange, onDelete, index, error }) => {
  const  note = process.find(i=> i.nameEn === item.note ) // Поиск для показа руского наименования  
     const errorKey = `weight${index}`;
     const errorValue = error[errorKey];  
  
  return (
    <div className='form__data_ingredient'>
          <p className='form__item_title font20Norm'>{item.name}</p>
          <label className='form__label_ing font20Norm'>
            <input
              type="number"
              id={`weigth${index}`}
              name={`weigth${index}`}
              value={item.totalWeight || ''}
              onChange={(e) => onWeightChange(item._id, e.target.value, item.group, index)} 
              max='1000'
              min='0,001'
              placeholder="0"
              className={`form__input_time font20Norm ${errorValue ? 'form__input_error' : ''}`}
            />  
            {item.measure}
            {errorValue && <span className="form__text_error font14Norm">{errorValue}</span>}
          </label> 
          <div className='form__data_ingredient_process'>
          <p className='p-m-l font20Norm'>{note ? note.nameRu : 
         <label className='form__label_group font20EB color'>  
          <span className="process-label">{process?.nameRu || 'Свежий'}</span>
           
       </label>
          }</p>
        
          <button type='button' className='gg-delete m-size' onClick={()=>onDelete(item._id, item.group)}/>
          </div>
        </div>
  );
};
 